export const BigArrow = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='477'
      height='55'
      fill='none'
      viewBox='0 0 477 55'
      aria-hidden='true'
      className={className}
    >
      <title>Arrow CTA</title>
      <path
        strokeLinecap='round'
        vectorEffect='non-scaling-stroke'
        d='M449 1L476 28.7619L449 54'
        stroke='currentColor'
      />
      <line
        strokeLinecap='round'
        vectorEffect='non-scaling-stroke'
        y1='28.5'
        x2='475'
        y2='28.5'
        stroke='currentColor'
      />
    </svg>
  );
};
